<template>
    <div class="introduction-fivepoint-container">
        <!-- map -->
        <div class="introduction-office-location-2">
            <div class="introduction-office-location-title title" v-html="$t(data.title2)" />
            <CommonComponentsAboutUsIntroductionFivePointsOfficeLocation />
        </div>
        <!-- 加入我们 -->
        <div class="introduction-join-us-3 global-limited-1360px-container">
            <CommonComponentsAboutUsIntroductionFivePointsColorCard :index="0" />
        </div>
        <!-- 奖学金计划 -->
        <div class="introduction-fellowship-program-4 global-limited-1360px-container">
            <CommonComponentsAboutUsIntroductionFivePointsColorCard :index="1" />
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { gsap } from 'gsap';
    const data = reactive({
        title1: 'global_aboutus_introduction_fivepoint_title_1',
        title2: 'global_aboutus_introduction_fivepoint_title_2',
        finacingcardList: [
            {
                title: 'global_aboutus_introduction_fivepoint_financing_title_1',
                png: '/AboutUs/Introduction/FivePoint/financing1.png',
            },
            {
                title: 'global_aboutus_introduction_fivepoint_financing_title_2',
                png: '/AboutUs/Introduction/FivePoint/financing2.png',
            },
            {
                title: 'global_aboutus_introduction_fivepoint_financing_title_3',
                png: '/AboutUs/Introduction/FivePoint/financing3.png',
            },
            {
                title: 'global_aboutus_introduction_fivepoint_financing_title_4',
                png: '/AboutUs/Introduction/FivePoint/financing4.png',
            },
            {
                title: 'global_aboutus_introduction_fivepoint_financing_title_5',
                png: '/AboutUs/Introduction/FivePoint/financing5.png',
            },
            {
                title: 'global_aboutus_introduction_fivepoint_financing_title_6',
                png: '/AboutUs/Introduction/FivePoint/financing6.png',
            },
        ],
    });
    onMounted(() => {
        const title = gsap.utils.toArray('.title') as Array<HTMLElement>;
        addSlideInUp(title);
    });
</script>

<style lang="less" scoped>
    .introduction-fivepoint-container {
        .title {
            text-align: left;
            font-size: .convert(@font-size-title-lg) [ @vw]; //64px
            line-height: normal;
            margin-top: .convert(100px) [ @vw];
            margin-bottom: .convert(80px) [ @vw];
        }
        .introduction-office-location-2 {
            position: relative;
            margin-top: .convert(100px) [ @vw];
            @media (max-width: @screen-mobile-width) {
                margin-top: .convert(40px) [ @vw-mobile];
            }
            .introduction-office-location-title {
                position: absolute;
                margin: 0;
                left: 50%;
                transform: translateX(-50%);
                z-index: 1;
                @media (max-width: @screen-mobile-width) {
                    position: relative;
                    left: 60%;

                    margin-bottom: .convert(20px) [ @vw-mobile];
                    font-size: .convert(32px) [ @vw-mobile];
                }
            }
            :deep(.star) {
                z-index: 1;
                position: absolute;
            }
        }
        .introduction-join-us-3{
          @media (max-width: @screen-mobile-width) {
              padding-top: .convert(20px) [ @vw-mobile];
            }
        }
        .introduction-fellowship-program-4 {
            padding-bottom: .convert(167px) [ @vw];
            @media (max-width: @screen-mobile-width) {
              padding-top: .convert(30px) [ @vw-mobile];
              padding-bottom: .convert(50px) [ @vw-mobile];
            }
        }
    }
</style>
